import { getArtistsWithArtworksCount } from 'api/artists'
import { ArtistsIds } from 'constants/artists'
import { useQuery } from 'react-query'

export function useMostPopularArtists() {
  return useQuery({
    queryKey: ['most-popular-artists'],
    queryFn: async () => {
      const { data } = await getArtistsWithArtworksCount([
        ArtistsIds.davidShrigley,
        ArtistsIds.wernerBronkhorst,
        ArtistsIds.aiWeiWei,
        ArtistsIds.invader,
      ])

      return data || []
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}
